/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, lazy } from "react";
import { useSelector } from "react-redux";

/** Common Components */
import Pagination from "../../../components/ui/pagination/Pagination";
import NoDataFound from "../../../components/ui/noDataFound/NoDataFound";

/** RTK Query */
import { useGetTimeSheetLogMutation } from "../../../app/services/timeSheetLogAPI";

/** CSS Files */
import "./TimesheetLog.scss";
import CardSection from "../../../components/ui/card/CardSection";
import { useNavigate } from "react-router-dom";

/** Lazily Loaded Components */
const TimesheetInfoCard = lazy(() => import("./feature/TimesheetinfoCard"));

const TimesheetLog = () => {

  const [timesheetData, settimesheetData] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const userId = useSelector(item => item.auth.user.userId)
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const navigate = useNavigate();

  const [getTimeSheetLog, {
    isLoading: isTimeSheetLoading,
    isSuccess: isTiemSheetSuccess,
    data: isTimeSheetData,
  },] = useGetTimeSheetLogMutation();

  // Functions
  const getTimeSheet = (pageObject) => {
    getTimeSheetLog(pageObject);
  };

  const handlePageChange = (page) => {
    const newPage = page.pageNumber || page;
    const newPageSize = page.pageSize || pageSize;

    setCurrentPage(newPage);
    setPageSize(newPageSize)
    const request = {
      pagination: { pageNumber: newPage, pageSize: newPageSize },
      filters: { searchText: "" },
      userId: userId,
    };
    getTimeSheet(request);
  };

  useEffect(() => {
    if (userId) {
      const request = {
        pagination: {
          pageNumber: 1,
          pageSize: 10,
        },
        filters: { searchText: "" },
        userId: userId,
      };
      getTimeSheet(request);
    }
  }, [userId]);

  useEffect(() => {
    if (isTiemSheetSuccess && isTimeSheetData) {
      if (isTimeSheetData.dataSource) {
        const sortedData = [...isTimeSheetData.dataSource].sort(
          (a, b) => new Date(b.startDate) - new Date(a.startDate)
        );
        settimesheetData(sortedData);
      }
  
      if (isTimeSheetData.totalRecord) {
        setTotalRowCount(isTimeSheetData.totalRecord);
      }
    }
  }, [isTiemSheetSuccess, isTimeSheetData]);

  const handleNavigate = (timesheetData) => {
    navigate(`/TimeSheet/MyTimeSheet`, {
      state: {
        startDate: timesheetData.startDate,
        endDate: timesheetData.endDate
      }
    });
  }

  return (
    <div className="timesheet-log center-top-space">
      <CardSection
        isContentLoading={isTimeSheetLoading}
        cardTitle={"Timesheet Log"}
      >
        <div className="timesheet-log-body">
          {timesheetData.length > 0 ? (
            timesheetData.map((data, index) => (
              <div className="timesheet-log-body-item" key={index + 1} onClick={() => handleNavigate(data)}>
                <TimesheetInfoCard {...data} />
              </div>
             
            ))
          ) : (
            <NoDataFound />
          )}
        </div>

        {timesheetData.length > 0 && (
          <div className="pagination-container mt-3">
            <Pagination
              currentPage={currentPage}
              pageSize={pageSize}
              totalCount={totalRowCount}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </CardSection>
    </div>

  );
};

export default TimesheetLog;
